export const enumPermisosBancolombia = Object.freeze({
  Recaudo_empresarial_PDP: 4004,
  Recaudo_empresarial_contingencia_PDP: 4005,
  Recaudo_empresarial_transacciones_PDP: 4006,
});
